import React from 'react';
import { Checkbox, InputAdornment, TextField, Typography } from '@mui/material';
import { Search } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';
import Button from '@src/new-components/Button';
import { COLOR } from '@src/styles/color';
import { StyledProjectListHeader } from './index.style';

const deleteButtonStyle = {
  height: '32px',
  padding: '4px 8px',
  borderRadius: '8px',
  border: `1px solid ${COLOR.borderDropdown}`,
};

const Header = ({
  search,
  onSearch,
  showInputSearch,
  bulkDeleteEnabled = false,
  selectedProjects = [],
  projectsOnPage = [],
  onToggleSelectAll,
  onDeleteSelected,
}) => {
  const { t } = useTranslation();

  const totalOnPage = projectsOnPage.length;
  const numSelected = selectedProjects.length;
  const allSelected = totalOnPage > 0 && numSelected >= totalOnPage;
  const someSelected = numSelected > 0 && numSelected < totalOnPage;
  const hasSelection = bulkDeleteEnabled && numSelected > 0;

  return (
    <StyledProjectListHeader>
      <div className="header-left">
        {bulkDeleteEnabled && totalOnPage > 0 && (
          <Checkbox
            className="select-all-checkbox"
            checked={hasSelection ? allSelected : false}
            indeterminate={hasSelection ? someSelected : false}
            onChange={onToggleSelectAll}
          />
        )}
        <Typography className="title">
          {hasSelection
            ? t('deselectAllProjects', {
                selected: numSelected,
                total: totalOnPage,
              })
            : t('projectList')}
        </Typography>
      </div>

      {hasSelection ? (
        <Button
          variant="outlined"
          startIcon={
            <DeleteIcon sx={{ fontSize: 20, color: COLOR.secondary[8] }} />
          }
          onClick={onDeleteSelected}
          customStyle={deleteButtonStyle}
          textProps={{ variantText: 'body-14-medium' }}
        >
          {t('delete')}
        </Button>
      ) : (
        showInputSearch && (
          <TextField
            size="small"
            className="text-field-project"
            variant="outlined"
            hiddenLabel={false}
            value={search}
            placeholder={t('searchProject')}
            onChange={onSearch}
            data-id="search-project"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
          />
        )
      )}
    </StyledProjectListHeader>
  );
};

export default Header;
